export const IA_CATEGORIES = {
  Animal:        { key: 'Animal',        color: '#26b36a', emoji: '🐾' },
  Construction:  { key: 'Construction',  color: '#e07b00', emoji: '🪖' },
  Domestique:    { key: 'Domestique',    color: '#6a0572', emoji: '🏠' },
  Musique:       { key: 'Musique',       color: '#e91e63', emoji: '🎵' },
  Urbain:        { key: 'Urbain',        color: '#00838f', emoji: '🏙' },
  'Voix humaine':{ key: 'Voix humaine',  color: '#0077b6', emoji: '🎤' },
  Véhicule:      { key: 'Véhicule',      color: '#c0392b', emoji: '🚗' },
};

// emoji pour les iconTypes non-catégorisés
export const ICON_EMOJI = {
  ...Object.fromEntries(Object.values(IA_CATEGORIES).map(({ key, emoji }) => [key, emoji])),
  diamond: null,  // label manuel — le marker cercle Plotly suffit dans la légende
  circle:  '', // IA sans catégorie
};

const CATEGORY_KEYWORDS = {
  Animal: [
    'animal', 'chien', 'chat', 'oiseau', 'insecte', 'grenouille', 'coq',
    'vache', 'cheval', 'mouton', 'porc', 'cochon', 'lapin', 'pigeon',
    'mouette', 'corbeau', 'merle', 'abeille', 'grillon', 'cigale',
    'dog', 'cat', 'bird', 'crow', 'seagull', 'cricket', 'frog', 'bee',
    'wildlife', 'faune', 'fauna',
  ],
  Construction: [
    'excavatrice', 'excavateur', 'compresseur', 'marteau', 'perceuse',
    'chantier', 'béton', 'beton', 'grue', 'foreuse', 'bulldozer', 'travaux',
    'scie', 'meuleuse', 'perforateur', 'pelleteuse', 'jackhammer',
    'drilling', 'hammer', 'drill', 'crane', 'excavator', 'construction',
    'compressor',
  ],
  Domestique: [
    'aspirateur', 'lave-vaisselle', 'machine à laver', 'sèche-linge',
    'four', 'micro-onde', 'microonde', 'réfrigérateur', 'refrigerateur', 'frigo',
    'ventilateur', 'climatisation', 'clim', 'chauffage', 'bouilloire',
    'cafetière', 'cafetiere', 'vacuum', 'dishwasher', 'washing', 'dryer',
    'domestique', 'ménage', 'menage', 'électroménager', 'electromenager',
  ],
  Musique: [
    'musique', 'music', 'concert', 'guitare', 'guitar', 'piano',
    'batterie', 'drums', 'violon', 'violin', 'trompette', 'trumpet',
    'flûte', 'flute', 'saxophone', 'sax', 'orchestre', 'orchestra',
    'chant', 'chanson', 'song', 'mélodie', 'melodie', 'melody', 'instrument',
    'basse', 'bass', 'synthé', 'synthe', 'synth',
  ],
  Urbain: [
    'foule', 'crowd', 'clameur', 'marché', 'marche', 'market', 'restaurant',
    'café', 'cafe', 'bar', 'rue', 'street', 'parc', 'park', 'ville', 'city',
    'urbain', 'urban', 'bruit de fond', 'ambiance', 'atmosphère', 'atmosphere',
    'fête', 'fete', 'festival', 'alarme', 'alarm', 'explosion',
    'feux d\'artifice', 'firework',
  ],
  'Voix humaine': [
    'voix', 'voice', 'parole', 'speech', 'discours', 'conversation',
    'dialogue', 'enfant', 'child', 'bébé', 'bebe', 'baby', 'cri', 'scream',
    'chuchotement', 'whisper', 'rire', 'laugh', 'pleur', 'cry',
    'humain', 'human', 'personne', 'person', 'appel', 'voix humaine',
  ],
  Véhicule: [
    'voiture', 'car', 'camion', 'truck', 'moto', 'motorcycle',
    'bus', 'train', 'metro', 'tramway', 'tram', 'avion', 'airplane',
    'hélicoptère', 'helicoptere', 'helicopter', 'véhicule', 'vehicule', 'vehicle',
    'klaxon', 'horn', 'moteur', 'engine', 'trafic', 'traffic',
    'freinage', 'brake', 'sirène', 'sirene', 'siren',
  ],
};

export function detectCategory(labelText) {
  if (!labelText) return null;
  const normalized = labelText.toLowerCase().trim();

  const exactMatch = Object.keys(IA_CATEGORIES).find(
    (cat) => cat.toLowerCase() === normalized
  );
  if (exactMatch) return exactMatch;

  for (const [category, keywords] of Object.entries(CATEGORY_KEYWORDS)) {
    if (keywords.some((kw) => normalized.includes(kw))) return category;
  }
  return null;
}
